import { React, useEffect } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import Lottie from 'lottie-react';

import NotReceivedList from './NotReceivedList';

import LoadingAnimation from '../../../Animation/NewLoading.json';

import { useLanguage } from '../../../Context/LanguageContext';

const NotReceivedHistory = (props) => {
  const {
    calcDateText,
    data,
    selectedPartnerGym,
    isOpenPartnerGymSales,
    isNotReceivedLoading,
    setIsNotReceivedLoading
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  useEffect(() => {
    setTimeout(() => {
      setIsNotReceivedLoading(false)
    }, 1000)
  }, [data])

  return (
    <TopLevelWrapper $isDark={isDark}>
      <InfoBox>
        <TitleWrapper>
          {/* <Title>{today.clone().format('YYYY년 MM월 미수금 내역')}</Title> */}
          <Title>{calcDateText() + ' ' + t('statistics.notReceived.title')}</Title>
        </TitleWrapper>
        {
          isNotReceivedLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
            :
            <TotalInfoBox>
              {
                isOpenPartnerGymSales ?
                  <NotReceivedList data={data} selectedPartnerGym={selectedPartnerGym}/>
                  :
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivate')}</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivateDesc')}</Text>
                  </NotOpenTextWrapper>
              }
            </TotalInfoBox>
        }
      </InfoBox>
    </TopLevelWrapper>
  )
}

export default NotReceivedHistory;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 24px 0px 24px 0px;
  
  width: 1020px;
  // height: 544px;

  margin-top: 38px;
  margin-bottom: 38px;

  border-radius: 30px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  background-color: ${props => props.theme.subBackground};
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-conetent: center;
  align-items: center;

  // width: 98%;
  width: 94.5%;
  // height: 544px;
`;

const AnimationBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  z-index: 5;
  
  margin-top: 24px;

  width: 100%;
  height: 439px;
  // height: 100%;

  // background-color: rgba(0, 0, 0, 0.2);
  background-color: ${props => props.theme.subBackground};
`;

const TotalInfoBox = styled.div`
  display: flex;
  flex-drection: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 437px;
`;

const NotOpenTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 160px;
  height: 160px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  // margin: 28px 0 0 13px;
  margin: 0;
  padding: 0;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;
